import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'

import PopupBlock, { IAttributes } from './PopupBlock'

import { ReactBlocks } from 'app/helpers/Blocks'

const Popup: React.FC<IWPGBlock> = (props) => {
  const attributes = props.attrs as IAttributes
  return (
    <PopupBlock
      {...attributes}
      description={<ReactBlocks innerBlocks={props.innerBlocks} withoutClientOnly />}
      showAsBlock={false}
      align="center"
    />
  )
}

export default Popup
